import request from '@/utils/request'
import URL from './urlTranslator'

export function getImageList(officeUuid) {
  return request({
    url: URL.sys.image,
    method: 'get',
    params: { officeUuid }
  })
}

export function querySystemImageFunc(officeUuid) {
  return request({
    url: URL.sys.querySystemImageUrl,
    method: 'get',
    params: { officeUuid }
  })
}

export function saveImage(data, officeUuid) {
  return request({
    url: `${URL.sys.updateImageDataUrl}?officeUuid=${encodeURIComponent(officeUuid)}`,
    method: 'post',
    data: data
  })
}

export function batchDelImage(data, params) {
  return request({
    url: URL.sys.image,
    method: 'post',
    data: data,
    params: params
  })
}
